import { userService } from '../../services';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { APIErrorMessage } from '../../../../shared/infra/api/APIErrorMessage';
import { User } from '../../models/user';

const getCurrentUser = createAsyncThunk<
  User,
  undefined,
  { rejectValue: APIErrorMessage }
>(
  'user/me',
  async (_, thunkapi) => {
    const result = await userService.getCurrentUser();

    if (result.isLeft()) {
      const error = result.value;
      return thunkapi.rejectWithValue(error);
    } else {
      return result.value.getValue();
    }
  },
  {
    condition: () => {
      if (!userService.hasToken()) {
        return false;
      }
    },
  },
);

export default getCurrentUser;
